import { useState } from "react";
import { Button } from "V2.0/common/button";
import { CalendarSearchEnabled } from "./CalendarSearchEnabled";
import { DaysToCheckSlotsFor } from "./DaysToCheckSlotsFor";
import { putRealTimeBookings } from "../../service";
import { message } from "antd";

export default function RealTimeBookings(props) {
  const { realTimeBooking, syncAssistant, workspaceId, assistantId, locked } =
    props;
  const [realTimeBookings, setRealTimeBookings] = useState({
    calendarSearchEnabled: realTimeBooking.calendarSearchEnabled || false,
    daysToCheckSlotsFor: realTimeBooking.daysToCheckSlotsFor || "2",
  });
  const [loading, setLoading] = useState(false);

  const updateCalendarSearchEnabled = () => {
    setRealTimeBookings((prevState) => {
      return {
        ...prevState,
        calendarSearchEnabled: !prevState.calendarSearchEnabled,
      };
    });
  };

  const updateDaysToCheckSlotFor = (data) => {
    setRealTimeBookings((prevState) => {
      return {
        ...prevState,
        daysToCheckSlotsFor: data,
      };
    });
  };

  const handleSave = async () => {
    message.loading("Updating Settings");
    setLoading(true);
    try {
      const response = await putRealTimeBookings({
        workspaceId,
        assistantId,
        payload: realTimeBookings,
      });
      if (response.status === 200) {
        message.destroy();
        message.success("Settings updated");
        setLoading(false);
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            realTimeBooking: response.data,
          };
        });
      }
    } catch (e) {
      message.destroy();
      message.error(
        e.response.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          "Failed to update settings"
      );
      setLoading(false);
      console.error("Error saving real time bookings");
    }
  };

  return (
    <div className="flex flex-col w-3/5 min-w-[600px] gap-y-8 border rounded-lg m-4">
      <div className="px-6 py-4 bg-gray-50 rounded-t-lg">
        <p className="text-md font-semibold text-gray-900">
          Calendar Appointments
        </p>
      </div>
      <div className="px-6 space-y-4">
        <CalendarSearchEnabled
          calendarSearchEnabled={realTimeBookings?.calendarSearchEnabled}
          updateCalendarSearchEnabled={updateCalendarSearchEnabled}
          locked={locked}
        />
        <DaysToCheckSlotsFor
          daysToCheckSlotsFor={realTimeBookings?.daysToCheckSlotsFor}
          updateDaysToCheckSlotFor={updateDaysToCheckSlotFor}
          disabled={!realTimeBookings?.calendarSearchEnabled || locked}
        />
      </div>
      <div className="bg-gray-50 px-6 py-3 text-right rounded-b-lg">
        {!locked && (
          <Button
            onClick={handleSave}
            loading={loading}
            disabled={locked}
          >
            Save
          </Button>
        )}
      </div>
    </div>
  );
}
